import React, { createContext, useContext, useState, useEffect } from 'react';
import { getLanguage, defaultLanguage } from '../locales';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(defaultLanguage);
  const [languageData, setLanguageData] = useState(getLanguage(defaultLanguage));



  useEffect(() => {
    // Load language from localStorage if available
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage && getLanguage(savedLanguage)) {
      setCurrentLanguage(savedLanguage);
      setLanguageData(getLanguage(savedLanguage));
    }
  }, []);

  const changeLanguage = (languageCode) => {
    const newLanguage = getLanguage(languageCode);
    if (newLanguage) {
      setCurrentLanguage(languageCode);
      setLanguageData(newLanguage);
      localStorage.setItem('selectedLanguage', languageCode);
      
      // Update document direction for RTL languages
      document.documentElement.dir = newLanguage.dir;
      document.documentElement.lang = languageCode;
    }
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = languageData.content;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key} in language ${currentLanguage}`);
        return key;
      }
    }
    
    return value || key;
  };

  const value = {
    currentLanguage,
    languageData,
    changeLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 